// extracted by mini-css-extract-plugin
export default {"-large":"npLKZX1eVEFfV_RV_6wt","dimensionsBox":"OuWyR6T_IsHFxikIlOY_"};